export function getCzechPieces(count: number, type: "granularity" | "amount") {
    if(type === "amount"){
        if (count === 0) return "kusů"
        if (count === 1) return "kus";
        if (count >= 2 && count <= 4) return "kusy";
        return "kusů";
    }else{
        if (count === 0) return "kusech"
        if (count === 1) return "kusu";
        if (count >= 2 ) return "kusech";
        return "kusech"
    }
}